/**
 * Environment of the service to use. In production, this should be set to PROD.
 *
 * @enum {string}
 */
export var Environment;
(function (Environment) {
    Environment["PROD"] = "PRODUCTION";
    Environment["QA"] = "QA";
    Environment["DEV"] = "DEVELOPMENT";
    Environment["LOCAL"] = "LOCAL";
})(Environment || (Environment = {}));
/**
 * Represents a region in which the user or service is located.
 * @enum {string}
 */
export var BillingGatewayRegion;
(function (BillingGatewayRegion) {
    BillingGatewayRegion["US"] = "US";
    BillingGatewayRegion["APAC"] = "APAC";
    BillingGatewayRegion["EU"] = "EU";
})(BillingGatewayRegion || (BillingGatewayRegion = {}));
/**
 * This class helps to construct the URLs needed to interact with the BGv3 API.
 */
var BillingGatewayEnvironment = /** @class */ (function () {
    // 'US' is the default region if not provided by consumer application
    function BillingGatewayEnvironment(environment, region) {
        if (region === void 0) { region = BillingGatewayRegion.US; }
        var _this = this;
        this.environment = environment;
        this.region = region;
        this.baseUrl = new URL((function () {
            switch (environment) {
                case Environment.PROD:
                    switch (_this.region) {
                        case BillingGatewayRegion.US:
                            return 'https://us.public.payments.fast.asurion.com/v1';
                        case BillingGatewayRegion.APAC:
                            return 'https://ap.public.payments.fast.asurion.com/v1';
                        case BillingGatewayRegion.EU:
                            return 'https://eu.public.payments.fast.asurion.com/v1';
                        default:
                            throw new Error("Region ".concat(_this.region, " is not supported"));
                    }
                case Environment.QA:
                    switch (_this.region) {
                        case BillingGatewayRegion.US:
                            return 'https://us.public.payments.npr.fast.asurion.com/qa';
                        case BillingGatewayRegion.APAC:
                            return 'https://ap.public.payments.npr.fast.asurion.com/qa';
                        case BillingGatewayRegion.EU:
                            return 'https://eu.public.payments.npr.fast.asurion.com/qa';
                        default:
                            throw new Error("Region ".concat(_this.region, " is not supported"));
                    }
                case Environment.DEV:
                    switch (_this.region) {
                        case BillingGatewayRegion.US:
                            return 'https://us.public.payments.npr.fast.asurion.com/dev';
                        case BillingGatewayRegion.APAC:
                            return 'https://us.public.payments.npr.fast.asurion.com/dev';
                        case BillingGatewayRegion.EU:
                            return 'https://us.public.payments.npr.fast.asurion.com/dev';
                        default:
                            throw new Error("Region ".concat(_this.region, " is not supported"));
                    }
                case Environment.LOCAL:
                    switch (_this.region) {
                        case BillingGatewayRegion.US:
                            return 'http://localhost:3000/v3';
                        case BillingGatewayRegion.APAC:
                            return 'http://localhost:3000/v3';
                        case BillingGatewayRegion.EU:
                            return 'http://localhost:3000/v3';
                        default:
                            throw new Error("Region ".concat(_this.region, " is not supported"));
                    }
            }
        })());
    }
    BillingGatewayEnvironment.prototype.getSessionEndpoint = function (applicationId, sessionToken) {
        var sessionEndpointUrl = new URL(this.baseUrl);
        sessionEndpointUrl.pathname += "/applications/".concat(encodeURI(applicationId), "/sessions");
        if (typeof sessionToken === 'string') {
            sessionEndpointUrl.pathname += "/".concat(encodeURI(sessionToken));
        }
        return sessionEndpointUrl;
    };
    BillingGatewayEnvironment.prototype.getTokenizeIntentEndpoint = function (applicationId, sessionToken) {
        var tokenizeIntentEndpointUrl = new URL(this.baseUrl);
        tokenizeIntentEndpointUrl.pathname += "/applications/".concat(encodeURI(applicationId), "/sessions/").concat(encodeURI(sessionToken), "/tokens/intent");
        return tokenizeIntentEndpointUrl;
    };
    BillingGatewayEnvironment.prototype.getSubmitPaymentDetailsEndpoint = function (applicationId, sessionToken) {
        var submitPaymentDetailsEndpointUrl = new URL(this.baseUrl);
        submitPaymentDetailsEndpointUrl.pathname += "/applications/".concat(encodeURI(applicationId), "/sessions/").concat(encodeURI(sessionToken), "/details");
        return submitPaymentDetailsEndpointUrl;
    };
    return BillingGatewayEnvironment;
}());
export { BillingGatewayEnvironment };
